import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';
import { HttpClient } from "@angular/common/http";
import { FileUploadListener } from './classes/FileUploadListener';
import { Observable, Observer } from 'rxjs';

@Injectable()
export class WishlistService extends BaseService{

  apiUrl = "Wishlist.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getDetailWishlist(country: string, store: string, mediaType: string, sessionToken: string,
    limit: number, offset: number, sortKey: string, status: string, currentItemType: string,
    genreIds?: string, priceRange?: string, quality?: string, bundleFilter?: string, visionPro3d?: string) {

    if (!currentItemType) currentItemType = "all";

    const urlParams = [
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "getDetailItemList"),
      new UrlParam("mediaType", mediaType),
      new UrlParam("limit", limit.toString()),
      new UrlParam("offset", offset.toString()),
      new UrlParam("sort", sortKey),
      new UrlParam("status", status),
      new UrlParam("itemType", currentItemType)
    ];

    if (genreIds !== undefined && genreIds !== null && genreIds !== "") {
      urlParams.push(new UrlParam("genreIds", genreIds));
    }
    if (priceRange !== undefined && priceRange !== null && priceRange !== "") {
      urlParams.push(new UrlParam("priceRange", priceRange));
    }
    if (quality !== undefined && quality !== null && quality !== "") {
      urlParams.push(new UrlParam("quality", quality));
    }
    if (bundleFilter !== undefined && bundleFilter !== null && bundleFilter !== "") {
      urlParams.push(new UrlParam("bundleFilter", bundleFilter));
    }
    if (visionPro3d !== undefined && visionPro3d !== null && visionPro3d !== "") {
      urlParams.push(new UrlParam("visionPro3d", visionPro3d));
    }

    let url = this.serverUrl + this.apiUrl + this.buildUrlParams.apply(this, urlParams);

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  getShortWishlist(country: string, store: string, sessionToken: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "getShortItemList_v2"),
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  setCustomPrice(
    country: string,
    store: string,
    itemType: string,
    idInStore: string,
    customPrice: string,
    customPriceHd: string,
    sessionToken: string,
    customPrice4k?: string
  ) {
    const urlParams = [
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "changeInitPrice"),
      new UrlParam("itemType", itemType),
      new UrlParam("idInStore", idInStore),
      new UrlParam("customPrice", customPrice)
    ];

    // Add HD price parameter only if provided (movies and TV seasons only)
    if (customPriceHd !== undefined && customPriceHd !== null) {
      urlParams.push(new UrlParam("customPriceHd", customPriceHd));
    }

    // Add 4K price parameter only if provided (Vudu store)
    if (customPrice4k !== undefined) {
      urlParams.push(new UrlParam("customPrice4k", customPrice4k));
    }

    let url = this.serverUrl + this.apiUrl + this.buildUrlParams.apply(this, urlParams);

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  addItem(country: string, store: string, itemType: string, sessionToken: string, idInStore: string, ignoreSdPrice?: boolean) {
    const urlParams = [
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "addItem"),
      new UrlParam("itemType", itemType),
      new UrlParam("idInStore", idInStore)
    ];

    // Add ignoreSdPrice parameter if enabled (only for movies and tvSeasons)
    if (ignoreSdPrice === true) {
      urlParams.push(new UrlParam("ignoreSdPrice", "1"));
    }

    let url = this.serverUrl + this.apiUrl + this.buildUrlParams.apply(this, urlParams);

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  removeItem(country: string, store: string, itemType: string, sessionToken: string, idInStore: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "removeItem"),
      new UrlParam("itemType", itemType),
      new UrlParam("idInStore", idInStore)
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  importImdbList(country: string, sessionToken: string, targetStores: string, imdbFile: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("targetStores", targetStores),
      new UrlParam("action", "importImdbList"),
      new UrlParam("imdbFile", imdbFile)
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  importLetterboxdList(country: string, sessionToken: string, targetStores: string, letterboxdFile: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("targetStores", targetStores),
      new UrlParam("action", "importLetterboxdList"),
      new UrlParam("letterboxdFile", letterboxdFile)
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  uploadFile(blob: Blob, fileUploadListener: FileUploadListener, country: string,
    targetStores: string, sessionToken: string): Observable<any> {

    return Observable.create((observer: Observer<any>) => {
      const formData: FormData = new FormData();
      const name = "imdbFile";
      formData.append(name, blob, name);

      const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
        new UrlParam('action', 'importImdbList'),
        new UrlParam('targetStores', targetStores),
        new UrlParam('country', country),
        new UrlParam('sessionToken', sessionToken)
      );
      const xhr = new XMLHttpRequest();

      xhr.timeout = 600000;
      xhr.ontimeout = function () {
        observer.error('timeout');
      };

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(xhr.response);
            observer.complete();
          }
          else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (e) => {
        if (fileUploadListener) {
          fileUploadListener.onProgress(blob, e.loaded / e.total * 100);
        }
      };

      //Here the post is done with a XMLHttpRequest because we want the onprogress event
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }

  uploadLetterboxdFile(blob: Blob, fileUploadListener: FileUploadListener, country: string,
    targetStores: string, sessionToken: string): Observable<any> {

    return Observable.create((observer: Observer<any>) => {
      const formData: FormData = new FormData();
      const name = "letterboxdFile";
      formData.append(name, blob, name);

      const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
        new UrlParam('action', 'importLetterboxdList'),
        new UrlParam('targetStores', targetStores),
        new UrlParam('country', country),
        new UrlParam('sessionToken', sessionToken)
      );
      const xhr = new XMLHttpRequest();

      xhr.timeout = 600000;
      xhr.ontimeout = function () {
        observer.error('timeout');
      };

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(xhr.response);
            observer.complete();
          }
          else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.upload.onprogress = (e) => {
        if (fileUploadListener) {
          fileUploadListener.onProgress(blob, e.loaded / e.total * 100);
        }
      };

      //Here the post is done with a XMLHttpRequest because we want the onprogress event
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }

  getShareWishlistUrl(country: string, store: string, mediaType: string, sessionToken: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "getShareWishlistUrl"),
      new UrlParam("mediaType", mediaType),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("debug", "0")
    );

    return this.get(url);
  }

}
